import { Card, SxProps, Theme } from "@mui/material";
import { Box, styled } from "@mui/system";
import React, { ReactNode } from "react";

// Define the prop types for CardTitle
interface CardTitleProps {
  subtitle?: string;
}

// Define the prop types for SimpleCard
interface SimpleCardProps {
  title?: string;
  subtitle?: string;
  icon?: ReactNode;
  children?: ReactNode;
  sx?: any; 
}

// Styled component for CardRoot
const CardRoot = styled(Card)(() => ({
  height: "100%",
  padding: "10px 0px 20px 0px",
  overflow: "auto",
  boxShadow: "none",
  borderRadius: "17px",
}));

// Styled component for CardTitle
const CardTitle = styled("div")<CardTitleProps>(({ subtitle }) => ({
  fontSize: "1.5rem",
  fontWeight: "500",
  textTransform: "capitalize",
  backgroundColor: "#fff",
  position: "relative",
  borderRadius: "0.375rem",
}));

// SimpleCard component
const SimpleCard: React.FC<SimpleCardProps> = ({
  children,
  title,
  subtitle,
  icon,
  sx,
}) => {
  return (
    <CardRoot elevation={6} sx={sx}>
      <CardTitle subtitle={subtitle}>{title}</CardTitle>
      {subtitle && <Box sx={{ mb: 2 }}>{subtitle}</Box>}
      {children}
    </CardRoot>
  );
};

export default SimpleCard;
